<div class="modal-header {{modalType}}">
  <i class="fal fa-info-circle" *ngIf="infoIcon && modalType === 'success'"></i>
  <i class="fal fa-exclamation-circle" *ngIf="infoIcon && (modalType === 'error' || modalType === 'warning')"></i>
  <span class="modal-title">{{title | translate}}</span>
  <button type="button" class="close" aria-label="Close" (click)="close()" *ngIf="showCloseIcon" mat-dialog-close>
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="section">
    <span *ngIf="contentText" class="text-center pre">{{contentText | translate}}</span>
    <ng-container *ngIf="contentTemplate">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </ng-container>
  </div>
  <div class="d-flex justify-content-center">
    <button type="button"
            class="btn button-primary"
            *ngIf="!buttons"
            (click)="close();dialogRef.close();">
      {{ 'ok' | translate }}
    </button>
    <ng-container *ngFor="let button of buttons;">
      <button type="button"
              class="btn {{button.type}} me-3"
              (click)="button.action(dialogRef);dialogRef.close();">
        <i class="fal {{button.icon}}" *ngIf="button.icon"></i>
        {{ button.title | translate }}
      </button>
    </ng-container>
  </div>
</div>
